module.exports = __webpack_public_path__ + "img/001.e1cbaa94.png";